import './theme_luvn.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeLuvn implements ITheme {
    id: string = 'luvn';
    matchIfHostNameContainsAny: string[] = ['luvn'];
    name: string = 'luvn';
    cssClassName: string = 'theme_luvn';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.home,
        NavigationItems.passengers,
        NavigationItems.passengerTransportationPermissions,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#6e112e',
        secondary: '#116e51',
        accent: '#116e51',
        warning: '#c24e0a',
        error: "#eb1111",
        red: "#e91b0c",
        grey: "#767676",
        bottomNavColor: '#ffffff'
    };
}
